<div class="card-header p-1">
    <div class="card-action-title">
        {{ headerOption.cardTitle | translate }}
    </div>
    <div class="card-action-element">
        <app-pcard-control-box [headerOption]="headerOption.controlBox"></app-pcard-control-box>
    </div>
</div>